module.exports = __webpack_public_path__ + "static/media/kominfo-team-9.fee7adc1.png";